// A Mini Planner draft has no itinerary yet, so its Traveller Preview is
// addressed by the draft's own id under the same `/preview/$itineraryId`
// route, marked with this prefix. Keeping the id in the path (rather than a
// search flag) means every in-preview link, tab and language switch carries it
// without each one having to remember an extra key.

const DRAFT_PREVIEW_PREFIX = 'draft-';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const toDraftPreviewId = (draftId: string): string =>
  `${DRAFT_PREVIEW_PREFIX}${draftId}`;

/** The draft id a preview route param names; null for an itinerary id. */
export const draftIdFromPreviewId = (
  previewId: string | null | undefined
): string | null => {
  if (!previewId?.startsWith(DRAFT_PREVIEW_PREFIX)) return null;
  const draftId = previewId.slice(DRAFT_PREVIEW_PREFIX.length);
  return UUID.test(draftId) ? draftId : null;
};

/** The traveller link to a draft's preview on the XT app at `base`. */
export const draftPreviewUrl = (base: string, draftId: string): string =>
  `${base.replace(/\/$/, '')}/preview/${toDraftPreviewId(draftId)}?view=traveller`;

/**
 * The traveller link a Mini Planner request opens: its draft until it is sent,
 * then the XT itinerary it became — so the preview follows that itinerary's
 * status (prices, stamp, availability) exactly as XT's and the Midlayer's do.
 */
export const requestPreviewUrl = (
  base: string,
  request: { id: string; itineraryId: string | null }
): string =>
  request.itineraryId
    ? `${base.replace(/\/$/, '')}/preview/${request.itineraryId}?view=traveller`
    : draftPreviewUrl(base, request.id);
